import {
  CollectionBreadcrumb,
  CollectionsList as CollectionsListComponent,
  GoBackLink,
  HeroCollection,
} from '@screens/Collection/components';
import ScrollToTop from '@components/ScrollToTop';
import { useTranslations } from 'next-intl';

export interface ICollectionsListProps {
  collections?: { handle: string; title: string }[];
}

export const CollectionsList: React.FC<ICollectionsListProps> = ({
  collections,
}) => {
  const tCatalog = useTranslations('Catalog');

  return (
    <div className="limited-width-container tw-flex tw-flex-col">
      <div className="tw-px-4 tw-py-3 desktop:tw-hidden">
        <GoBackLink currentPathTitle={tCatalog('allCollections')} />
        <p className="title-xs tw-pb-2 tw-pt-3">{tCatalog('allCollections')}</p>
      </div>
      <div className="tw-mb-6 tw-mt-4 tw-hidden desktop:tw-block">
        <CollectionBreadcrumb currentPathTitle={tCatalog('allCollections')} />
      </div>
      <div className="tw-order-2 tw-flex tw-justify-center tw-py-6 tw-text-center desktop:tw-hidden">
        <ScrollToTop />
      </div>
      <div className="tw-order-1 tw-mt-6 desktop:tw-order-none desktop:tw-mt-0">
        <HeroCollection
          title={tCatalog('allCollections')}
          descriptionHtml={`<p>
                ${tCatalog('allCollectionsByAlphabeticalOrder')}
              </p>`}
        />
      </div>
      <div className="desktop:tw-my-6">
        <CollectionsListComponent collections={collections} />
      </div>
    </div>
  );
};
